import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { api } from './api';
import AuthCard from './AuthCard';

const Forgot = () => {
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) return setError("Enter your username or email.");
    setError('');
    setLoading(true);
    try {
      await api('request-reset', { identifier: identifier.trim() });
      setSent(true);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <AuthCard title="Check your email">
        <Alert variant="success">
          If that account has a verified email address, we've sent a link to reset the password.
          It expires in an hour.
        </Alert>
        <p className="text-muted small">
          Nothing arrived? Check your spam folder. Accounts that never added a verified email
          can't be reset here.
        </p>
        <div className="text-center"><Link to="/login">Back to log in</Link></div>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Reset your password">
      <Form onSubmit={submit}>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group controlId="identifier">
          <Form.Label>Username or email</Form.Label>
          <Form.Control autoFocus autoCapitalize="none" autoCorrect="off"
            value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
        </Form.Group>
        <Button type="submit" block disabled={loading}>
          {loading ? 'Sending…' : 'Send reset link'}
        </Button>
        <div className="text-center mt-3"><Link to="/login">Back to log in</Link></div>
      </Form>
    </AuthCard>
  );
};

export default Forgot;
